import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { SnBrandLogoComponent } from './components/brand-logo/brand-logo.component';
import { SnBrandNameComponent } from './components/brand-name/brand-name.component';
import { FsLoaderScreenComponent } from './components/loader-screen/loader-screen.component';
import { ISnBrandLogosConfig } from './interfaces/brand-logos-config.interface';
import { SN_BRAND_LOGOS } from './providers/brand-logos.provider';
import { SN_BRAND_NAME } from './providers/brand-name.provider';

@NgModule({
  imports: [CommonModule],
  exports: [SnBrandNameComponent, SnBrandLogoComponent, FsLoaderScreenComponent],
  declarations: [SnBrandNameComponent, SnBrandLogoComponent, FsLoaderScreenComponent],
})
export class SnBrandModule {
  public static forRoot(
    name: string,
    logos: ISnBrandLogosConfig,
  ): ModuleWithProviders<SnBrandModule> {
    return {
      ngModule: SnBrandModule,
      providers: [
        {
          provide: SN_BRAND_NAME,
          useValue: name,
        },
        {
          provide: SN_BRAND_LOGOS,
          useValue: logos,
        },
      ],
    };
  }
}
